/** @file Narrows a mesh record to its skinned geometry (VALIDATION at `target` for a rigid mesh). */
import type { MeshAtt } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';

type Skinned = Extract<MeshAtt['geometry'], { kind: 'skinned' }>;

/** The skinned geometry of `mesh` (the same object, mutable inside a draft); rigid meshes are refused. */
export function skinnedDraft(mesh: MeshAtt): Skinned {
  const g = mesh.geometry;
  if (g.kind === 'skinned') return g;
  return throwError('VALIDATION', undefined, { path: 'target', hint: `${mesh.name} is rigid: call mesh.setBinding with binding 'skinned' first` });
}
